import React from 'react';

import KeycloakApi, {User} from "../../lib/keycloak";

export default function Avatar(props: { user: User }) {
	return <div className="avatar">
		<img src={ props.user.picture ?? "https://cdn.vectorstock.com/i/500p/66/14/default-avatar-photo-placeholder-profile-picture-vector-21806614.jpg" } alt={`${props.user.name}'s profile picture`} />
		<span className="name">{props.user.name}</span>
		<span className="email">{props.user.email}</span>
	</div>
}

/**
 * Reactive current-user hook.
 *
 *   undefined → still determining (initial silent check in flight)
 *   null      → determined: not logged in
 *   User      → logged in
 *
 * Seeds from api.currentUser() (non-interactive) on mount, then stays in sync
 * via the 'login' event. Never triggers an interactive popup.
 */
export function useUser(api: KeycloakApi): User | null {
	const [user, setUser] = React.useState<User | null>(null);

	React.useEffect(() => {
		let active = true;

		const unsubscribe = api.on('login', e => {
			if (active) setUser(e.user);
		});

		api.trySilentLogin()
			.then(u  => { if (active) setUser(prev => prev ?? u); })
			.catch(() => { if (active) setUser(prev => prev ?? null); });

		return () => {
			active = false;
			unsubscribe();
		};
	}, [api]);

	return user;
}